import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var UploadCloud = createReactComponent("UploadCloud", ["svg", defaultAttributes, [["polyline", {
  points: "16 16 12 12 8 16",
  key: "8cfiuk"
}], ["line", {
  x1: "12",
  y1: "12",
  x2: "12",
  y2: "21",
  key: "16to6l"
}], ["path", {
  d: "M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3",
  key: "xftpgh"
}], ["polyline", {
  points: "16 16 12 12 8 16",
  key: "8cfiuk"
}]]]);
export default UploadCloud;